import script from "./AppHana2Page.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHana2Page.vue?vue&type=script&setup=true&lang=js"

import "./AppHana2Page.vue?vue&type=style&index=0&id=58ca983f&lang=css"

const __exports__ = script;

export default __exports__